import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { GlobalState } from '../global.state';

@Injectable()
export class CommonService {

  constructor(
    private apiService: ApiService,
    private _state: GlobalState
  ) { }
  initTermAndYear() {
    this.apiService.get('common/years').subscribe((years) => {
      this._state.notifyDataChanged('[YEARS] UPDATE', years);
    });
    this.apiService.get('common/semesters').subscribe((years) => {
      this._state.notifyDataChanged('[SEMESTERS] UPDATE', years);
    });
    this.apiService.get('common/current_semester').subscribe((semester) => {
      this._state.notifyDataChanged('[SEMESTER] UPDATE', semester);
    });
    this.apiService.get('common/current_year').subscribe((years) => {
      this._state.notifyDataChanged('[YEAR] UPDATE', years);
    });
    this.apiService.get('common/workload_workteach_edit_status').subscribe((status) => {
      this._state.notifyDataChanged('[LEADER EDIT STATUS] UPDATE', status);
    });
    this.apiService.get('common/workload_workteach_leader_up100per_status').subscribe((status) => {
      this._state.notifyDataChanged('[LEADER UP100PER STATUS] UPDATE', status);
    });
  }
}
